import Cookie from './cookie';
import '../util/web-tracker';
import uuid from 'uuid/v4';
const session_uuid = uuid();
if (!window._ACE_LOGGER) {
  window._ACE_LOGGER = [];
}
const logger = new window.Tracker('cn-hangzhou.log.aliyuncs.com', 'aliyun-page', 'web');
const gatherParams = ({ level, group, tags = [], message, params }) => {
  return {
    uid: Cookie.get('login_aliyunid_pk'),
    date: new Date().getTime(),
    group: group ? group : 'default',
    tags: tags,
    level: level,
    message: message,
    params: JSON.stringify(params),
    requestId: session_uuid,
    url: location.href,
  };
};
const _push = (message, params, others) => {
  const logParams = gatherParams({
    message,
    params,
    ...others,
  });
  window._ACE_LOGGER.push(logParams);
  // localhost不上报，检测有没有端口号就可以
  if (location.port) {
    return;
  }
  for (const key in logParams) {
    if (logParams.hasOwnProperty(key)) {
      const element = logParams[key];
      logger.push(key, element);
    }
  }
  logger.logger();
  // error,fatal上报至clue
  if (logParams.level == 'warn' || logParams.level == 'error' || logParams.level == 'fatal') {
    window._$ACE_tracker.log({
      code: 11,
      msg: logParams.message,
      sampleRate: 1.0,
      c1: logParams.uid,
      c2: logParams.level,
      c3: logParams.tags,
      c4: logParams.group,
      c5: logParams.requestId,
      c6: logParams.params,
    });
  }
};
export default class Logger {
  static debug(message, params = {}, others = {}) {
    others.level = 'debug';
    _push(message, params, others);
  }
  static info(message, params = {}, others = {}) {
    others.level = 'info';
    _push(message, params, others);
  }
  static error(message, params = {}, others = {}) {
    others.level = 'error';
    _push(message, params, others);
  }
  static warn(message, params = {}, others = {}) {
    others.level = 'warn';
    _push(message, params, others);
  }
  static fatal(message, params = {}, others = {}) {
    others.level = 'fatal';
    _push(message, params, others);
  }
}



// WEBPACK FOOTER //
// ./src/components/logger.js